<template>
    <TableFilter :filter-refs="$refs"
                 @apply-filter="applyFilter"
    >
        <div class="filter_item">
            <TextFilter :label-text="$t('common.company')"
                        columnName="companyName"
                        ref="filter_companyName"
            ></TextFilter>
            <TextFilter :label-text="$t('common.vatId')"
                        columnName="vatNumber"
                        ref="filter_vatNumber"
            ></TextFilter>
            <TextFilter :label-text="$t('common.street')"
                        columnName="street"
                        ref="filter_street"
            ></TextFilter>
            <TextFilter :label-text="$t('common.postcode')"
                        columnName="postCode"
                        ref="filter_postCode"
            ></TextFilter>
            <TextFilter :label-text="$t('common.city')"
                        columnName="city"
                        ref="filter_city"
            ></TextFilter>
            <FromToFilter :label-text="$t('customRating.table.rating1')"
                          columnName="rating1"
                          ref="filter_rating1"
            ></FromToFilter>
            <FromToFilter :label-text="$t('customRating.table.rating2')"
                          columnName="rating2"
                          ref="filter_rating2"
            ></FromToFilter>
            <FromToFilter :label-text="$t('customRating.table.rating3')"
                          columnName="rating3"
                          ref="filter_rating3"
            ></FromToFilter>
            <DateFilter :label-text="$t('common.updateDate')"
                        columnName="lastUpdateTime"
                        ref="filter_lastUpdateTime"
            ></DateFilter>
        </div>
    </TableFilter>
</template>

<script>
import TextFilter from "@/components/newFilter/TextFilter";
import FromToFilter from "@/components/newFilter/FromToFilter";
import DateFilter from "@/components/newFilter/DateFilter";
import TableFilter from "@/components/newFilter/TableFilter";

export default {
    components: {TableFilter, TextFilter, FromToFilter, DateFilter},
    data() {
        return {};
    },
    methods: {
        applyFilter(filters) {
            this.$emit("apply-filter", filters);
        }
    }
};
</script>